// extracted by extract-css-chunks-webpack-plugin
module.exports = {"productName":"styles__productName__1gaN_"};